import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { AccountService } from "./account.service";

@Injectable({
  providedIn: "root",
})
export class IsMarketGuard implements CanActivate {
  constructor(private router: Router, private accountService: AccountService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let isMarket;
    this.accountService.isFullMarketUser.subscribe((res) => {
      isMarket = res;
    });

    if (isMarket) {
      return true;
    }

    this.router.navigate(["home"]);
    return false;
  }
}
